// extracted by mini-css-extract-plugin
export var printerCard = "_bh-1";
export var printerCardConfigured = "_bh-2";
export var printerCardError = "_bh-3";
export var printerCardsContainer = "_bh-0";
export var printerIcon = "_bh-8";
export var printerIconConfigured = "_bh-5";
export var printerIconContainer = "_bh-4";
export var printerIconError = "_bh-6";
export var printerIconUnconfigured = "_bh-7";
export var workstationsTableCard = "_bh-9";